import React from 'react';
import {
  Button,
  colors,
  ListItem,
  ListItemSecondaryAction,
  ListItemText
} from '@material-ui/core';
import { Transaction } from 'src/types';
import { RMATransactionIncludedListing } from 'src/redux/slices/rma/types';

interface Props {
  transactionItem: Transaction & RMATransactionIncludedListing;
  selectedRmaId?: number;
  included_serial?: number[];
  onSelectTransactionItem: (item: Transaction) => void;
}

const component = ({
  transactionItem,
  selectedRmaId,
  included_serial,
  onSelectTransactionItem
}: Props) => {
  const isIncludedOnSerial = included_serial?.includes(
    transactionItem?.listing_id || 0
  );

  return (
    <ListItem divider dense>
      <ListItemText
        primary={transactionItem?.serial_no}
        secondary={
          <a
            href={`/app/products/${transactionItem?.product_id}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: 'inherit',
              textDecoration: 'none',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.color = colors.blue[500])
            }
            onMouseLeave={(e) => (e.currentTarget.style.color = 'inherit')}
          >
            {transactionItem?.product_name}
          </a>
        }
        style={{ maxWidth: '430px' }}
      />
      <ListItemSecondaryAction>
        <Button
          size="small"
          color="primary"
          variant="outlined"
          style={{
            marginLeft: 10,
            background:
              selectedRmaId === transactionItem?.listing_id
                ? colors.green[400]
                : isIncludedOnSerial || transactionItem?.is_included
                ? colors?.lightBlue[400]
                : '',
            color:
              selectedRmaId === transactionItem?.listing_id ||
              isIncludedOnSerial ||
              transactionItem?.is_included
                ? 'white'
                : 'black'
          }}
          disabled={transactionItem?.isDeleted === 1}
          onClick={() => onSelectTransactionItem(transactionItem)}
        >
          {selectedRmaId === transactionItem?.listing_id
            ? 'FOR RMA'
            : isIncludedOnSerial || transactionItem?.is_included
            ? 'Included'
            : 'Select'}
        </Button>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export const RMATransactionItem = React.memo(component);
